module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/proposal-view-modal/rv-proposal-vew/rv-proposal-vew.component.scss
// module id = ./src/app/account-client/component/account-client-details/proposal-view-modal/rv-proposal-vew/rv-proposal-vew.component.scss
// module chunks = main